import React from 'react'

import { AxiosError } from 'axios'

import { Flex } from '@driftt/dds'

import OpportunitiesTab from 'pages/CCRMAccountDetailsPage/OpportunitiesTab'


interface OpportunitiesTabProps {
  accountId: string
  salesforceData: any | undefined
  opportunities: any | undefined
  opportunitiesError: AxiosError | null
}

const DrawerOpportunitiesTab: React.FC<OpportunitiesTabProps> = ({
  accountId,
  salesforceData,
  opportunities,
  opportunitiesError
}) => {
  
  return (
    <Flex direction='column' fullHeight fullWidth css={{ 
      backgroundColor: '$gray2', 
      padding: '16px',
      height: 'calc(100% - 31px)',
      overflow: 'scroll',
    }}>
      <OpportunitiesTab
          accountId={accountId}
          salesforceData={salesforceData}
          opportunities={opportunities}
          opportunitiesError={opportunitiesError}
        />
    </Flex>
  )
}

export default DrawerOpportunitiesTab
